<template>
<!-- WHAT: A components to collect rows model data (Copied from BtDimsMetricsModel).
   HISTORY:
   * V251204.1: Supported 2-way binding: Initialized form fields from v-model.
   * V250708.1: Modified v-col sizes to always fill up the row.
   * V250707.1: 1st release.
-->
<v-form lazy-validation
   ref="form"
   v-model="isFormValid"
>
   <v-row class="px-2 pb-2">
      <v-col cols="12" class="py-0"
      >
         <v-autocomplete multiple persistent-hint required deletable-chips small-chips
            ref="columns"
            autocomplete="off"
            class="py-0"
            placeholder="select one or more columns..."
            hint="* Columns"
            :counter="schemaColumns.length"
            :items="schemaColumns"
            :rules="[rules.requiredArray]"
            v-model="columns"
            @change="columnsChanged"
         ></v-autocomplete>
      </v-col>
   </v-row>
   <v-row>
      <v-col cols="12" class="pb-0">
         <bt-metrics-model
            :max="0"
            :query-submitted="querySubmitted"
            :schemas="schemas"
            v-model="metricsData"
            @form-valid="metricsDataChanged"
         />
      </v-col>
   </v-row>
</v-form>
</template>

<script>
import BtMetricsModel from './BtMetricsModel.vue';
import { isEmpty } from '../mixins/bt-mixin.js';

const NAME = "BtRowsModel";
const VERSION = 'V251204.1';

export default {
   name: NAME,

   components: {
      BtMetricsModel
   },

   props: {
      value: {
         type: Object,
         default: () => ({})
      },
      debug: {
         type: Boolean,
         default: false
      },
      initialModel: {
         type: Boolean
      },
      schemas: {
         type: Array,
         required: true,
         default: () => []
      },
      querySubmitted: {
         type: Boolean,
         required: true
      },
   },

   data() {
      return {
         rules: {
            requiredArray: value => !!value.length || "Value is required!"
         },
         isFormValid: false,
         isFormChanged: false,
         columns: [],
         metricsData: {}
      }
   },

   computed: { },

   watch: {
      initialModel: {
         immediate: true,
         handler(val) {
            if (val) this.init();
         }
      },

      schemas: {
         immediate: true,
         deep: true,
         async handler(val) {
            // this.alert('in ' + NAME + '/watch: schemas=' + JSON.stringify(val));
            // this.columns = [];
            // this.formChanged();
            this.schemaColumns = val?.length ? val.map(col => col.column_name) : [];
            this.init();

            // this.isFormChanged = false;

            this.$nextTick(() => {
               // this.formChanged();
               this.$refs.columns?.focus();
            });
         },

         // querySubmitted: {
         //    handler(val) {
         //       if (val) this.isFormChanged = false;
         //    }
         // }
      }
   },

   methods: {
      alert(msg) {
         if (this.debug) {
            alert(`${NAME} ${VERSION} says:\n${msg}`);
         }
      },

      log(msg, always =false) {
         if (this.debug || always) {
            console.log(`-----${NAME} ${VERSION} says => ${msg}`);
         }
      },

      init() {
         if (isEmpty(this.value) || !this.schemaColumns?.length) {
            this.columns = [];
            this.metricsData = {};
            this.isMetricsModelValid = false;
         } else {
            const { columns, whereClause } = this.value;

            this.columns = columns.filter(col =>
               this.schemaColumns.some(sc => sc === col)
            );

            this.metricsData = {
               metrics: [],
               ...(whereClause && { whereClause: whereClause })
            }

            this.isMetricsModelValid = true;
         }
      },

      columnsChanged() {
         this.formChanged();
      },

      metricsDataChanged(val) {
         // alert('in metricsDataChanged(): val=' + val);
         // alert('in metricsDataChanged(): val=' + JSON.stringify(this.metricsData));
         this.isMetricsModelValid = val;
         this.formChanged();
      },

      formChanged() {
         let emitVal = false;
         this.isFormValid = this.$refs.form?.validate();
         // alert('in formChanged(): isFormValid=' + this.isFormValid);
         if (this.isFormValid && this.isMetricsModelValid) {
            delete this.metricsData.metrics;
            const modelData = {
               columns: this.columns,
               ...this.metricsData
            };

            this.$emit('input', modelData);
            emitVal = true;
         }

         this.$emit('form-valid', emitVal);
      }
   },

   mounted() {
      // alert(`in ${NAME}.mounted(): `);
      if (this.initialModel === undefined)
         this.init();
   }
}
</script>

<style scoped>
</style>